import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IUserRepository } from '../../repositories/interfaces/iUserRepository';
import { IPaymentSwitchVerifyParams, CSRFTokenRequest } from '../../../entity';

export interface IPaymentSwitchVerifyUseCase {
    execute(payload: IPaymentSwitchVerifyParams, csrfToken: CSRFTokenRequest): Promise<any>;
}

export class PaymentSwitchVerifyUseCase implements IPaymentSwitchVerifyUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get userRepo(): IUserRepository {
        return container.resolve<IUserRepository>(DI.REPOSITORIES.IUserRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(payload: IPaymentSwitchVerifyParams, csrfToken: CSRFTokenRequest): Promise<any> {
        return await this.userRepo.paymentSwitchVerify(payload, csrfToken);
    }
}
